import { viewpointActions } from '.';
import { apiService } from '../../services';
import { detailConstants, projConstants } from '../constants';
import { labelType } from "../../components/enums/labelType"

export const syncActions = {
    syncProject,
    syncIssue
}

function syncProject(projId) {
    return dispatch => {
        apiService.getProjects([projId]).then(projects => {
            const project = projects[0];
            apiService.getArrayOData(`label?$filter=type in ('${labelType.Tags}')`, project.tagIds).then(data => {
                project.tags = data;
            });

            if (project.workPhaseIds) {
                apiService.getArrayData(`label?$filter=type in ('${labelType.WorkPhase}')`, project.workPhaseIds).then(workPhases => {
                    project.workPhases = workPhases;
                }).catch(err => {
                    console.log("Can't load the workphase in project.", err.message);
                });
            }

            dispatch(setCurrentProject(project));
        }).catch(err => {
            console.log(err.message);
        })
    }

    function setCurrentProject(project) {
        return {
            type: projConstants.PROJ_OPEN,
            payload: project
        }
    }
}

function syncIssue(id) {
    return dispatch => {
        apiService.getArrayOData('issue', [id]).then(issues => {
            const issue = issues[0];
            if (issue.viewpointIds.length) {
                dispatch(viewpointActions.getViewpoint(issue.viewpointIds));
            }

            dispatch(updateIssue(issue));
        }).catch(err => {
            console.log(err);
        });
    }

    function updateIssue(issue) {
        return {
            type: detailConstants.DETAIL_SELECT,
            payload: issue
        }
    }
}